export default "__VITE_ASSET__DC3rAtEU__"